/* Component in the ScheduleScene to display the Characters */
import React from "react"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import styles from "../../../styles/ScheduleSceneItem.module.css"

const ScheduleSceneCharacters2 = ({title, act}) => {

  return (
    <div className={`text-center py-2 mb-2 px-2 ${styles.SceneBox}`} >
    <Row>
    <Col xs={12} className="px-0" md={{span: 5, offset: 3}} >
    {act ? (
    <div className="mb-4 mt-2" >
      <p className={`${styles.CharactersTitle } mb-1`} >CAST</p>
    <Row >
    <Col xs={12} >
    <div className={`${styles.BgBox} text-center px-3 mx-0`}>
      <p>{act} </p>
    </div>
    </Col>
    </Row>
    </div>
    ) : ("") }
    <p className={`${styles.CharactersTitle } mt-2 mb-1`} >BACKGROUND - DOUBLES - STUNT ARTISTS</p>
    <Row >
    <Col xs={12}>
    <div className={`${styles.BgBox} text-center px-3 mx-0`}>
      <p>{title} </p>
    </div>
    </Col>
    </Row>
    </Col>
    </Row>
    </div>
  )
}

export default ScheduleSceneCharacters2
